<div class="dialog-content">
  <h1 mat-dialog-title>
    {{ 'administration.user.item.userRoles.title' | translate }}
  </h1>
  <div mat-dialog-content>
    <div class="checkbox-group">
      <div class="checkbox-group__title">
        {{ 'administration.user.item.userRoles.dialog.selectRole' | translate }}
      </div>
      <div *ngFor="let group of userItemFacade.roleList$ | async | keyvalue" class="group">
        <div class="group__title">
          {{ group.key | startCase | titlecase }}
        </div>
        <div *ngFor="let role of group.value | sortBy : 'asc'" class="group__roles">
          <mat-checkbox
            [value]="role"
            [checked]="isRoleChecked(role, group.key)"
            (change)="changeCheckbox(group.key, $event.checked, $event.source.value)"
          >
            {{ 'administration.user.item.userRoles.roles.' + role | translate }}
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
    <ui-action-button
      [action]="buttonAction.Save"
      [type]="buttonType.Primary"
      (buttonClick)="confirm()"
    ></ui-action-button>
  </div>
</div>
